
import {
    defineComponent,
} from '@vue/composition-api';
import CheckBoxInputListWithOneSelect from '@fr/vue/components/inputs/CheckBoxInputListWithOneSelect.vue';
import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
import HintTooltip from '@ve/components/hintTooltip/desktop/HintTooltip.vue';
import FilterListItem from '@ve/components/searchFilters/filterList/desktop/FilterListItem.vue';
import TextCommon from '@ve/components/inputs/TextCommon.vue';
import useMealsFilterSerp from '../common/useMealsFilterSerp';

export default defineComponent({
    name: 'meals-filter-list',
    components: {
        FilterListItem,
        CheckBoxInputListWithOneSelect,
        CheckBoxInput,
        HintTooltip,
        TextCommon,
    },
    setup(props, ctx) {
        return useMealsFilterSerp(ctx);
    },
});
